module.exports = __webpack_public_path__ + "img/felc-FE赛区.d8066794.png";